import React from 'react';
import { createRoot } from 'react-dom/client';
import { initBackendConfig } from './config/backend';
import './FuncoesGerais/api';
import './tacoma-ds.css';
import './theme.css';
import App from './App';
import { AuthProvider } from './App/Context/auth';
import { SidebarProvider } from './App/Context/sidebar';
import { PermissoesSidebarProvider } from './App/Context/permissoesSidebar';

initBackendConfig();

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <AuthProvider>
        <PermissoesSidebarProvider>
            <SidebarProvider>
                <App />
            </SidebarProvider>
        </PermissoesSidebarProvider>
    </AuthProvider>
);
